/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Dec 27 2023
 **/

import { EventHandler } from "@rfice/eventhandler";

import { useNotice, useUsers } from "@/frameworks/core/API";
import { NotificationAtom, NotificationNoticeAtom, NotificationSettingsAtom } from "./atom";

export default function useNotification() {
	const userAPI = useUsers();
	const noticeAPI = useNotice();

	const read = (readKey: string) => {
		EventHandler.emit("notificationLogs:readByKey", readKey);
		return userAPI.notificationLogs.readByKey.execute({ readKey });
	};
	const readAll = async (category: "NORMAL") => {
		switch (category) {
			case "NORMAL":
				EventHandler.emit("notificationLogs:readAll");
				return userAPI.notificationLogs.readAll.execute({ category });
			default:
				return { error: "invalid category" };
		}
	};
	const readNotice = (noticeId: string) => noticeAPI.notification.read.execute({ noticeId });
	const readAllNotice = async () => noticeAPI.notification.readAll.execute({});

	return {
		read,
		readAll,
		readNotice,
		readAllNotice,
		atom: {
			notification: NotificationAtom,
			notificationNotice: NotificationNoticeAtom,
			settings: NotificationSettingsAtom
		}
	};
}
